import { InfoRounded } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import SvgToIcon from "../../../../../icons/SvgToIcon";

import CustomToolTip from "../../../../../components/CustomTooltip";
import { getPluralizedTitle } from "../../utils";
import OverviewGauge from "../EntityTypeGauge/OverviewGauge";

export default function CardHeaderSection({
  colors,
  entityTypeInfo,
  entityTypeMetadata,
}) {
  const { total_entities, at_risk, are_protected } = entityTypeMetadata;
  const coverage = (are_protected / total_entities) * 100;
  const excludedEntities = total_entities - at_risk - are_protected;

  const headerInfo = [
    {
      text: "At Risk",
      color: colors.error_light_label_text,
      value: at_risk,
    },
    {
      text: "Protected",
      color: colors.success_soft_label_text,
      value: are_protected,
    },
  ];

  return (
    <Box display="flex" height="58px" gap={2}>
      <Box width="58px" height="100%">
        <SvgToIcon IconLogo={entityTypeInfo.icon} width="100%" height="100%" />
      </Box>
      <Box display="flex" flex={1} justifyContent="space-between">
        <Box display="flex" flexDirection="column" paddingTop="4px" gap={0.5}>
          <Box display="flex" gap={0.5} alignItems="center">
            <Typography variant="subtitle1" color={colors.text_primary}>
              {total_entities}{" "}
              <Typography
                component="span"
                variant="body1"
                color={colors.text_primary}
                sx={{ marginLeft: "3px" }}
              >
                {getPluralizedTitle(
                  entityTypeInfo.title,
                  entityTypeMetadata.total_entities
                )}
              </Typography>
            </Typography>
            {excludedEntities > 0 && (
              <CustomToolTip
                title={
                  excludedEntities === 1
                    ? "1 entity is excluded from risk"
                    : `${excludedEntities} entities are excluded from risk`
                }
                placement="top"
              >
                <InfoRounded sx={{ width: "12px", color: colors.grey_light }} />
              </CustomToolTip>
            )}
          </Box>
          <Box display="flex" gap={0.5}>
            {headerInfo.map((item) => (
              <Box
                key={item.text}
                display="flex"
                height="18px"
                alignItems="center"
                gap={0.75}
                padding="0 6px"
              >
                <Box
                  sx={{
                    backgroundColor: item.color,
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                  }}
                />
                <Typography variant="caption" color={colors.grey_700}>
                  {item.value} {item.text}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        <Box>
          <OverviewGauge value={coverage} />
        </Box>
      </Box>
    </Box>
  );
}
